/**
 * Scope set used whenever the current route does not declare one.
 *
 * MSAL silently swaps an empty scope list for the OIDC-only set, which makes
 * Azure AD hand back a Microsoft Graph access token instead of a Trainplanet
 * API one. The API then rejects it with 401 "Signature verification failed",
 * since Graph tokens cannot be verified by third parties. (TRAIN-2332)
 */
export const DEFAULT_SCOPES = [process.env.VUE_APP_MICROSOFT_API_URL + "/Scope.Order.Basic"];
